export default {
  "Loop as a GIF": "Ripeti come GIF",
  "without sound": "senza suono",
  "Final output duration": "Durata finale dell'esportazione",
};
